import React from 'react'
import YnsIcon from '../../icons/YnsIcon'

/**
 * Rating component that displays and optionally allows setting a 5-star rating
 * @param {Object} props
 * @param {number} [props.value] - Initial rating value (0-5)
 * @param {function} [props.onChange] - Callback when rating changes
 * @param {string} [props.className] - Additional CSS classes
 */
const Rating = ({ value: initialValue = 0, onChange, className = '' }) => {
  const [rating, setRating] = React.useState(initialValue)
  const [hoverValue, setHoverValue] = React.useState(0)
  const isInteractive = !!onChange

  const handleMouseEnter = (index) => {
    if (isInteractive) {
      setHoverValue(index)
    }
  }

  const handleMouseLeave = () => {
    if (isInteractive) {
      setHoverValue(0)
    }
  }

  const handleClick = (index) => {
    if (isInteractive) {
      setRating(index)
      onChange?.(index)
    }
  }

  const displayValue = hoverValue || rating

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {[1, 2, 3, 4, 5].map((index) => (
        <span
          key={index}
          className={`focus:outline-none ${
            isInteractive ? 'cursor-pointer' : 'cursor-default'
          }`}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(index)}
          role={isInteractive ? 'button' : undefined}
          tabIndex={isInteractive ? 0 : undefined}
        >
          <YnsIcon
            name={index <= displayValue ? 'star-solid' : 'star'}
            className={`h-6 w-6 ${
              index <= displayValue
                ? 'text-yellow-400'
                : 'text-gray-300 dark:text-gray-600'
            }`}
          />
        </span>
      ))}
    </div>
  )
}

export default Rating
